import { Heading, Icon, Stack } from '@chakra-ui/react';


import RadialBarChart from '../../components/RadialBarChart';

export function SalesInvoicesChart({ text, icon, data }: any) {
    // const data = [
    //     {
    //         "name": "Errored",
    //         "total": 6,
    //         "fill": "#ff004c"
    //     },
    //     {
    //         "name": "Completed",
    //         "total": 24,
    //         "fill": "#00ff80"
    //     },
    //     {
    //         "name": "Processed",
    //         "total": 30,
    //         "fill": "#00b3ff"
    //     },
    //     {
    //         "name": "Processing",
    //         "total": 70,
    //         "fill": "#035F89"
    //     },
    //     {
    //         "name": "All Documents",
    //         "total": 100,
    //         "fill": "#020F81"
    //     }
    // ]
    // const data_process = data.map((d: any) => {
    //     console.log(d);
    // })

    return (
        <Stack
            w={'24.2%'}
            h={'100%'}
            rounded={'xl'}
            boxShadow={'base'}
            bg={'white'}
            pt={2}
        >
            <Stack
                px={4}
                pb={2}
                direction={'row'}
                borderBottom={'1px'}
                borderBottomColor={'gray.100'}
                justify={'start'}
                align={'center'}
            >
                <Icon
                    as={icon}
                    fontSize={'2xl'}
                    color={'primary.400'}
                />
                <Heading fontSize={'md'} textAlign={'center'}>{text}</Heading>
            </Stack>
            <Stack justify={'center'} align={'center'}>
                <RadialBarChart 
                    id={text.replace(/\s/g, '')}
                    labels={["Processing", "Processed"]}
                    colors={['rgb(5, 68, 94)', 'rgba(5, 68, 94, 0.9)']}
                    series={[data?.pending+data?.processing, data?.processed+ data?.approved]}
                />
            </Stack>
            {/* <SimpleGrid
                templateColumns={'1fr 1fr'}
                spacingX={4}
                spacingY={2}
                w={'full'}
                justifyContent={'center'}
                alignItems={'center'}
            >
                {
                    data.map(d => (
                        <Stack direction={'row'} align={'center'}>
                            <Box bg={d.fill} h={'10px'} width={'10px'}></Box>
                            <Text>{d.name}</Text>
                        </Stack>
                    ))
                }
            </SimpleGrid> */}
            {/* <ResponsiveContainer width={'100%'} height={'100%'}>
                <RadialBarChart
                    innerRadius="20%"
                    outerRadius="110%"
                    data={data}
                    startAngle={360}
                    endAngle={0}
                >
                    <RadialBar label={{ fill: '#fff', position: 'insideStart' }} background dataKey='total' />
                    <Tooltip />
                </RadialBarChart>
            </ResponsiveContainer> */}
        </Stack>
    )
}